import {
  getMergedQueryParams,
  getQueryString,
} from "Utils/navigation/queryParameterUtils";

import { componentClicked } from "Store/analytics/analyticsSlice";
import { useStepStatusSelector } from "Store/steps/stepsSelectors";
import { findStep } from "Store/steps/stepsUtils";
import { login } from "Utils/KeycloakWrapper";
import { buttonNextTrackId } from "Utils/analytics";
import { getAppPath } from "Utils/appUtils";
import { isDefined } from "Utils/functions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

export const useBankIdLoginHandler = (): ((
  additionalParams?: Record<string, string>,
) => void) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { startStepId, steps } = useStepStatusSelector();

  return (additionalParams = {}) => {
    dispatch(componentClicked(buttonNextTrackId("keycloak-login")));

    const startStep = findStep(steps, startStepId);
    if (!isDefined(startStep) || !isDefined(startStep.uri)) {
      return;
    }

    const queryParams = getMergedQueryParams([
      history.location.search,
      additionalParams,
    ]);
    const redirectUri = `${startStep.uri}${getQueryString(queryParams)}`;

    login({ redirectUri: `${getAppPath()}${redirectUri}` });
  };
};
